
import { defineComponent, reactive, watch } from 'vue';
import Icone from '@/core/components/Icone.vue';
import { useTelaBase } from '@/core/composables/TelaBase';
import { IDTOProdutoDefinicao } from '@/models/DTO/Cadastros/Produtos/IDTOProdutoDefinicao';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useModalBase } from '@/core/composables/ModalBase';
import { IDTOSelecaoProduto } from '@/models/DTO/Estoques/IDTOSelecaoProduto';
import { ETipoSelecaoProduto } from '@/models/Enumeradores/Estoques/ETipoSelecaoProduto';
import { IDTORastreabilidade } from '@/models/DTO/Estoques/Rastreabilidade/IDTORastreabilidade';
import ConsultaProdutos from './ConsultaProdutos.vue';
import { ETipoRastreabilidade } from '@/models/Enumeradores/Estoques/Rastreabilidade/ETipoRastreabilidade';

export default defineComponent({
  name: 'ConsultaProdutosModal',
  props: {
    visivel: {
      type: Boolean,
    },
    empresa: {
      type: Number,
      required: true,
    },
    tipoSelecao: {
      type: Number,
      default: 2,
    },
    preSelecao: {
      type: Array as () => IDTOSelecaoProduto[],
      default: [] as IDTOSelecaoProduto[],
    },
  },
  components: {
    Icone,
    ConsultaProdutos,
  },
  emits: ['update:visivel', 'confirmacao', 'cancelamento'],
  setup(props, { emit }) {
    const { telaBase, apresentarMensagemAlerta } = useTelaBase();
    const { modalBase } = useModalBase(props, emit);

    const state = reactive({
      titulo: '',
      empresa: 0,
      codigosSelecionados: [] as number[],
      produtos: [] as IDTOProdutoDefinicao[],
      confirmado: false,
    });

    function preencherTitulo() {
      if (props.tipoSelecao === ETipoSelecaoProduto.Consulta) {
        state.titulo = 'Consulta de Produtos';
      } else if (props.tipoSelecao === ETipoSelecaoProduto.SelecaoMultipla) {
        state.titulo = 'Selecionar Produtos';
      } else {
        state.titulo = 'Selecionar Produto';
      }
    }

    function limparTela() {
      state.empresa = 0;
      state.titulo = '';
      state.produtos = [] as IDTOProdutoDefinicao[];
      state.confirmado = false;
    }

    function confirmar() {
      if (!UtilitarioGeral.validaLista(props.preSelecao)) {
        if (UtilitarioGeral.validaLista(state.codigosSelecionados)) {
          if (props.tipoSelecao === ETipoSelecaoProduto.SelecaoUnica && state.codigosSelecionados.length > 1) {
            apresentarMensagemAlerta('Selecione apenas um lote!');
            return;
          }
          emit('confirmacao', state.codigosSelecionados);
          modalBase.computedVisivel = false;
        } else {
          apresentarMensagemAlerta('Nenhum produto foi selecionado!');
        }
      } else {
        if (props.tipoSelecao === ETipoSelecaoProduto.SelecaoUnica && state.produtos[0].estoquesRastreabilidades.filter((item) => item.qtdSelecionada > 0).length > 1) {
          apresentarMensagemAlerta('Selecione apenas um lote!');
          return;
        }
        const selecionados = [] as IDTORastreabilidade[];
        let continuar = true;
        state.produtos.forEach((p, ip) => {
          if (continuar) {
            let total = 0;
            if (UtilitarioGeral.validaLista(p.estoquesRastreabilidades)) {
              p.estoquesRastreabilidades.forEach((e, ie) => {
                if (e.qtdSelecionada > 0) {
                  state.produtos[ip].estoquesRastreabilidades[ie].codigoItem = p.codigoItem;
                  state.produtos[ip].estoquesRastreabilidades[ie].codigoItemNotaFiscal = p.codigoItemNotaFiscal;
                  if (state.produtos[ip].tipoRastreabilidade === ETipoRastreabilidade.Nenhum) {
                    state.produtos[ip].estoquesRastreabilidades[ie].identificador = '';
                  }
                  selecionados.push(state.produtos[ip].estoquesRastreabilidades[ie]);
                  total += e.qtdSelecionada;
                }
              });
            }
            if (total !== p.quantidade && p.quantidade > 0) {
              apresentarMensagemAlerta(`A quantidade selecionada do produto ${p.codigoInterno} é diferente da quantidade necessária!`);
              continuar = false;
            }
          }
        });
        if (continuar) {
          emit('confirmacao', selecionados);
          state.confirmado = true;
          modalBase.computedVisivel = false;
        }
      }
    }

    watch(async () => modalBase.computedVisivel, async () => {
      telaBase.carregando = true;
      if (!state.confirmado) {
        emit('cancelamento');
      }
      limparTela();
      if (modalBase.computedVisivel) {
        state.empresa = props.empresa;
        preencherTitulo();
      }
      telaBase.carregando = false;
    });

    return {
      props,
      state,
      modalBase,
      confirmar,
    };
  },
});
